export { SimpleTxWatcher } from '@safe-global/utils/services/SimpleTxWatcher'
